enum BusinessBranchDisplayAddress {
    Display,
    DoNotDisplay,
    SuburbOnly
}

export default BusinessBranchDisplayAddress
